export const apiPath = '/v2/library_templates';
const actionType = 'LIBRARY';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
